<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-4 text-h2"> Jonas Premier </v-col>
    </v-row>

    <v-row class="ml-3">
      <v-row class="mb-3 text-h5">Jonas Premier Credentials</v-row>
      <v-row>
        <v-form v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="credentials.clientId"
                  :rules="clientIdRules"
                  :counter="6"
                  label="Client ID"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="credentials.username"
                  label="User Name"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="credentials.password"
                  :rules="passwordRules"
                  :type="showPassword ? 'text'  : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  label="Password"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12" class="text-end">
                <v-btn class="ml-4" @click="submit" color="primary">
                  submit
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-row>
    </v-row>

    <v-divider class="my-8"></v-divider>

    <v-row class="ml-3">
      <v-row class="mb-3 text-h5">NoahFace Settings</v-row>
      <v-row>Setup some options here too for mode=grey etc</v-row>
    </v-row>
    <v-divider class="my-8"></v-divider>

    <v-row class="ml-3">
      <v-row class="mb-3 text-h5">Screen Details</v-row>
      <v-row>{{ screenDetails }}</v-row>
    </v-row>
  </v-container>
</template>

<script>
// const { getJobCostItems } = require('../services/jonas');

export default {
  name: 'JonasPremierTree',

  data: () => ({
    valid: false,
    credentials: {
      clientId: '318009',
      username: 'JC_API',
      password: 'Garth123',
    },
    clientIdRules: [(v) => /\d{6}/.test(v) || 'Client ID should be 6 digits'],
    passwordRules: [(v) => !!v || 'Password is required'],
    showPassword: false,
    jonasData: {
      jobs: [],
      costItems: [],
    },
  }),
  methods: {
    submit() {
      // getJobCostItems(this.credentials)
      //   .then((response) => {
      //     console.log(response.data);
      //   })
      //   .catch((error) => {
      //     console.log('Couldn\'t fetch Jonas Cost Items');
      //     console.log(error);
      //   });
    },
  },
  computed: {
    screenDetails() {
      return '';
    },
  },
};
</script>
